import Swiper, { Scrollbar, A11y, Mousewheel, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/scrollbar";
import "swiper/css/navigation";

Swiper.use([Scrollbar, A11y, Mousewheel, Navigation]);

if (document.querySelector(".category-swiper")) {
    document.querySelectorAll(".category-swiper").forEach((slider) => {
        let breakpoints = {
            1280: {
                slidesPerView: 5,
            },
            1024: {
                slidesPerView: 4,
            },
            600: {
                slidesPerView: 3,
            },
            300: {
                slidesPerView: 2,
            },
        };
        let spv = 5;

        new Swiper(slider, {
            allowTouchMove: true,
            slidesPerView: spv,
            // spaceBetween: 25,
            scrollbar: {
                el: ".swiper-scrollbar",
            },
            mousewheel: {
                enabled: true,
                forceToAxis: true,
            },
            breakpoints: breakpoints,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            a11y: {
                prevSlideMessage: "Föregående bild",
                nextSlideMessage: "Nästa bild",
            },
        });

        slider.querySelectorAll(".swiper-button").forEach((button) => {
            button.style.display = "flex";
        });
    });
}
